import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=fd6e1888&"
import script from "./summary.vue?vue&type=script&lang=ts&"
export * from "./summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports